import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_MULTI_PROMPT_DATA } from './schema';

const MUTATION = gql`
  mutation CreateMultiPromptBlocks(
    $customerId: ID!
    $description: String!
    $inputFields: [JSON!]!
    $toolList: JSON!
    $generationTool: GenerationToolEnum
    $allInstructionsData: JSON
    $urlExtractions: [UrlExtractionInput!]
    $title: String
    $length: Int
    $moreInfo: JSON
    $projectId: ID
  ) {
    createMultiPromptBlocks(
      customerId: $customerId
      description: $description
      inputFields: $inputFields
      toolList: $toolList
      generationTool: $generationTool
      allInstructionsData: $allInstructionsData
      urlExtractions: $urlExtractions
      title: $title
      length: $length
      moreInfo: $moreInfo
      projectId: $projectId
    ) {
      ...MultiPromptData
    }
  }
  ${FRAGMENT_MULTI_PROMPT_DATA}
`;

export const createMultiPromptBlocks = async ({
  customerId,
  description,
  inputFields,
  toolList,
  generationTool,
  allInstructionsData,
  urlExtractions,
  title,
  length,
  moreInfo,
  projectId,
}) => {
  const variables = {
    customerId,
    description,
    inputFields,
    toolList,
    generationTool,
    allInstructionsData,
    urlExtractions,
    title,
    length,
    moreInfo,
    projectId,
  };

  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp(response.data);
};
